import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=3c642f0f&scoped=true&"
var script = {}
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=3c642f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c642f0f",
  null
  
)

export default component.exports